const keys = {
    0: {hex: '#00843D', name: 'standard'}, // standard
    1: {hex: '#E4A700', name: 'non-standard'}, // non-standard
    2: {hex: '#C40024', name: 'standard'}, // arkiv
}
export const getColorStatus = (id) => {
    return keys[id];
};
